import React, { memo } from "react";

import { transformDateToLocalDateString } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { getVehiclePlate } from "../helpers";
import { VehicleWizardSceneProps } from "../types";

/** Korak "PP aparat": aparat sa serijskim brojem, rok valjanosti i podsjetnik prije isteka. */
const ExtinguisherScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const expiration = vehicleInfo.fireExtinguisherExpirationDate
    ? transformDateToLocalDateString(new Date(vehicleInfo.fireExtinguisherExpirationDate))
    : "31.03.2027.";

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="flex items-center justify-center h-[12.6rem] p-[10px] rounded-t-lg bg-gradient-to-br from-rose-50 to-rose-100">
          <img
            src="/media/images/vehicles/fire-extinguisher.webp"
            alt=""
            className="w-full h-full object-contain mix-blend-multiply"
          />
        </div>
        <div className="p-5">
          <div className="text-sm font-bold text-slate-800">
            {vehicleInfo.fireExtinguisherName || VEHICLE_WIZARD_SAMPLE.extinguisherName}
          </div>
          <div className="mt-1 text-[0.7rem] text-slate-400">
            {vehicleInfo.fireExtinguisherSerialNumber || VEHICLE_WIZARD_SAMPLE.extinguisherSerial}
            {" · "}
            {vehicleInfo.fireExtinguisherWeight ?? 6} kg
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Rok valjanosti</div>
          <div className="mt-3 flex items-center gap-3">
            <div className="flex flex-col items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-rose-400 to-rose-500 text-white flex-shrink-0">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="16" rx="2" />
                <path d="M16 3v4M8 3v4M3 10h18" />
              </svg>
            </div>
            <div>
              <div className="text-base font-bold text-slate-800">{expiration}</div>
              <div className="text-[0.65rem] text-slate-400">Servis svake godine</div>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Podsjetnik prije isteka"
          subtitle={`${getVehiclePlate(vehicleInfo)} · 30 dana ranije`}
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(ExtinguisherScene);
